import { createSelector } from "reselect";

// Actions
export const ADD_FILTER_CATEGORY = "ADD_FILTER_CATEGORY";
export const TOGGLE_OPTION_ACTIVE = "TOGGLE_ACTIVE";
export const TOGGLE_CATEGORY_COLLAPSE = "TOGGLE_CATEGORY_COLLAPSE";
export const UPDATE_OPTION_VALUE = "UPDATE_OPTION_VALUE";
export const SET_OPTION_ACTIVE = "SET_OPTION_ACTIVE";
export const CLEAR_ALL = "CLEAR_ALL";

export function addFilterCategory(category, id) {
    return {
        type: ADD_FILTER_CATEGORY,
        id: id,
        category: category
    }
}

export function toggleActive(categoryId, optionName) {
    return {
        type: TOGGLE_OPTION_ACTIVE,
        categoryId,
        optionName
    }
}

export function toggleCategoryCollapse(categoryId) {
    return {
        type: TOGGLE_CATEGORY_COLLAPSE,
        categoryId
    }
} 

export function setOptionValue(categoryId, optionName, value) {
    return {
        type: UPDATE_OPTION_VALUE,
        categoryId,
        optionName,
        value,
    }
}

export function setOptionActive(categoryId, optionName, active) {
    return {
        type: SET_OPTION_ACTIVE,
        categoryId,
        optionName,
        active
    }
}

export function clearAll() {
    return {
        type: CLEAR_ALL
    }
}

let opChanged = {
    categoryId: "",
    nextOption: {
        name: "", 
        value: "", 
        active: null,
    },
    prevOption: {
        name: "", 
        value: "", 
        active: null,
    }
}

// Reducers
export function filters(state = {filters: {}, optionChanged: opChanged}, action) {
    let optionChanged;

    switch(action.type) {

        case ADD_FILTER_CATEGORY:
            return {...state, filters: {...state.filters, [action.id]: action.category}};

        case TOGGLE_OPTION_ACTIVE:
            let optionsToggleActive = newToggleOptionActive(state.filters[action.categoryId], action.optionName);
            return {...state, optionChanged: optionsToggleActive.opChanged, filters: {...state.filters, [action.categoryId]: {...state.filters[action.categoryId], options: optionsToggleActive.newOptions}}};

        case TOGGLE_CATEGORY_COLLAPSE:
            return {...state, filters: {...state.filters, [action.categoryId]: {...state.filters[action.categoryId], collapsed: !state.filters[action.categoryId].collapsed}}}
        
        case UPDATE_OPTION_VALUE:
            let optionsNewVal = newUpdateOptionValue(state.filters[action.categoryId], action.optionName, action.value);
            return {...state, optionChanged: optionsNewVal.opChanged, filters: {...state.filters, [action.categoryId]: {...state.filters[action.categoryId], options: optionsNewVal.newOptions}}};

        case SET_OPTION_ACTIVE:
            let optionsNewActive = newUpdateOptionActive(state.filters[action.categoryId], action.optionName, action.active);
            return {...state, optionChanged: optionsNewActive.opChanged, filters: {...state.filters, [action.categoryId]: {...state.filters[action.categoryId], options: optionsNewActive.newOptions}}};
        case CLEAR_ALL:
            let ns = newClearAllFilters(state.filters)
            return {...state, filters: ns}
        default:
            return state;
    }
}

// Selectors
export const selectActiveFiltersCount = createSelector(
    state => state.filters.filters,
    filters => activeFiltersCount(filters)
)

// Helpers

export function newClearAllFilters(filters) {
    let ns = {...filters};
    for (const filter in ns) {
        ns[filter].options.map(op => {
            op.active = false;
            // handle range
            if (ns[filter].type === "range") {
                if (op.name === "filterBounds") {
                    let minMaxOption = getOptionByName("minMax", ns[filter]);
                    op.value = minMaxOption.value;
                }
            }
        })
    }
    return ns;
}


// --- Change option state functions
export function newToggleOptionActive(category, optionName) {
    let prevOption;
    let nextOption;
    let newOptions = category.options.map((op) => {
        if (op.name === optionName) {
            prevOption = op;
            nextOption = {...op, active: !op.active};
            return nextOption;
        };
        return op;
    })

    return {
        newOptions: newOptions,
        opChanged: changedOption(category.dataPoint, prevOption, nextOption)
    }
}

export function newUpdateOptionValue(category, optionName, value) {
    let prevOption;
    let nextOption;
    let newOptions = category.options.map(op => {
        if (op.name === optionName) {
            prevOption = op;
            nextOption = {...op, value: value};
            return nextOption;
        }
        return op
    })

    return {
        newOptions: newOptions,
        opChanged: changedOption(category.dataPoint, prevOption, nextOption)
    }
}

export function newUpdateOptionActive(category, optionName, active) {
    let prevOption;
    let nextOption;
    let newOptions = category.options.map(op => {
        if (op.name === optionName) {
            prevOption = op;
            nextOption = {...op, active: active};
            return nextOption;
        }
        return op
    })

    return {
        newOptions: newOptions,
        opChanged: changedOption(category.dataPoint, prevOption, nextOption)
    }
}

export function getOptionByName(name, category) {
    for (let i = 0; i < category.options.length; i++) {
        let option = category.options[i];
        if (option.name === name) return category.options[i];
    }
}

function activeFiltersCount(filters) {
    let count = 0;
    for (const filter in filters) {
        filters[filter].options.forEach(op => {
            if (op.active) count++;
        })
    }
    return count;
}

function changedOption(categoryId, pOption, nOption) {
    return {
        categoryId: categoryId,
        prevOption: pOption,
        nextOption: nOption
    }
}